import { Image } from './common';
import { BaseBusinessService } from './services';
import { PaymentProvider } from '@src/@data/types/paymentProviders';

export enum CalendarType {
  Time = 'time',
  Slot = 'slot',
}

export interface BaseCalendar {
  id: string;
  type: CalendarType;
  title: string;
  image?: Image;
}

export interface CompanyCalendar extends BaseCalendar {
  enabled: boolean;
}

export interface CompanyCalendarDetails {
  title: string;
  type: CalendarType;
  isPubliclyVisible: boolean;
}

export interface CompanyCalendarWorkHours {
  boundToWeekdays: boolean;
  startFrom: string;
  template: string[];
  timeZone?: string;
}

export interface WorkHoursWithInvalidReservationDates {
  workHours: CompanyCalendarWorkHours;
  invalidReservationDates: string[];
}

interface BaseCalendarSettings {
  autoConfirm: boolean;
  minStartDelay: number;
  step: number;
  stripeEnabled: boolean;
  daysToGenerate: number;
}

export interface CompanyCalendarSettings extends BaseCalendarSettings {
  companyPaymentProviders: PaymentProvider[];
}

export interface CompanyCalendarContent {
  image?: Image;
  details: CompanyCalendarDetails;
  workHours: CompanyCalendarWorkHours;
  settings: CompanyCalendarSettings;
}

export interface CalendarInvalidReservationDates {
  invalidReservationDates: string[];
}

interface BusinessCalendarService extends BaseBusinessService {
  calendarId: string;
  calendarSelectionEnabled: boolean;
  serviceId: string;
  minStartDelay: number;
}

export interface BusinessCalendar extends BaseCalendar, BaseCalendarSettings {
  disabledAt: string;
  isPubliclyVisible: boolean;
  services?: BusinessCalendarService[];
  timeZone: string;
  workHours?: CompanyCalendarWorkHours;
}

export interface BusinessCalendarDayWorkHours {
  date: string;
  dayOff: boolean;
  end?: string;
  start?: string;
}
